// timelineService.js
import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

export const downloadFormsByTypeService = async (projectId, formType, formLabels, fromDate, toDate) => {
    const host = process.env.REACT_APP_WORK_CALENDAR_API_URL;
    const apiPath = `forms/${projectId}/download-project-forms-by-type/${formType}`;

    const request = {
        url: `https://${host}/${apiPath}`,
        // url: `http://localhost:3001/${apiPath}`,
        method: 'POST',
        host: host,
        path: apiPath,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            formLabels: formLabels,
            separate: true,
            fromDate: fromDate,
            toDate: toDate
        }),
        data: {
            formLabels: formLabels,
            separate: true,
            fromDate: fromDate,
            toDate: toDate
        },
        region: Config.AWS_REGION,
        service: 'execute-api',
    };
    const signedRequest = await createSignedRequest(request);
    const response = await axios(signedRequest);
    // console.log("🚀 ~ response:", response)
    return response.data;
};
